<template>
  <div
    class="container-fluid d-print-block report_table p-0"
    style="background-color:#f2f2f2;font-family: Source Sans Pro; overflow: visible;margin-left: 11px !important;"
  >
    <div class="d-print-block" style="background-color:#f2f2f2;border:none; margin-bottom: 50px;">
      <div
        class="card-body d-print-block"
        style="font-family: Source Sans Pro;font-style: normal;font-weight: normal;font-size: 14px;line-height: 18px;color: #29342E;"
      >
        <div id="card" ref="report" class="d-print-block print">
          <div class="row d-print-block">
            <!-- FIRST CARD: LOGO, STATUS AND GENERAL INFO -->
            <div class="col-12 card" style="margin-top: -12px">
              <div id="report">Report</div>
              <hr id="first_hr" />

              <table id="mid_table" align="right">
                <tr>
                  <td style="width:100%">
                    <img
                      class="report-logo"
                      src="@/assets/img/ALsumLogo.png"
                      alt="alsum logo"
                      crossorigin="anonymous"
                    />
                  </td>
                  <td>
                    <span id="powerd_by">powered by</span>
                  </td>
                  <td style="padding-left:0px;">
                    <img class="Agsift-logo" src="@/assets/img/AgsiftLogo.png" alt="Agsift" />
                  </td>
                </tr>
              </table>

              <div>
                <div>
                  <ul
                    class="nav nav-pills nav-justified d-print-block"
                    id="inspection_role"
                    role="tablist"
                  >
                    <li class="nav-item waves-effect waves-light d-print-block">
                      <a
                        class="nav-link active width200 singleLink text-center"
                        role="tab"
                      >Inspection Report</a>
                    </li>
                  </ul>
                </div>
                <!-- REPORT STATUS -->
                <!-- <center>
                  <div class="col-2">
                    <span class="first_str" style="text-align:center;">Status :</span>
                    <span id="approved_name">
                      <span v-if="reports.averageCheckSum.status === 'Passed'" class="passed">Passed</span>
                      <span v-else-if="reports.averageCheckSum.status === 'Failed'" class="failed">Failed</span>
                      <span v-else class="borderline">Borderline</span>
                    </span>
                  </div>
                </center>-->
                <!-- REPORT STATUS END -->
                <!-- GENERAL INFORMATION -->
                <div class="table_top">
                  <table class="table-borderless table-generalInfo">
                    <tbody>
                      <tr>
                        <!--<td class="tdleft">
                          <span class="first_str" style="top:93px;">Approval Status :</span>
                          <span id="approved_name">
                            <span v-if="reports.approval_status">
                              <button id="approved_button">
                                <span id="status_btn">Approved</span>
                              </button>
                            </span>
                            <span v-else>
                              <button id="pen_button">
                                <span id="status_btn_pen">Pending</span>
                              </button>
                            </span>
                          </span>
                        </td>
                        <td id="mid_td"></td>
                        <td class="tdright col-5">
                          <span
                            class="header-title first_str"
                            v-if="reports.approval_status"
                          >Approved By :</span>
                          <span id="approved_name">{{reports.approver}}</span>
                        </td>-->
                        <td class="col"></td>
                      </tr>
                      <tr>
                        <td class="tdleft col-5">
                          <span class="header-title first_str">Lot Number :</span>
                          <span class="tdleft">{{ reports.generalInfo.lot_num }}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright col-5">
                          <span class="header-title first_str">Vendor Number :</span>
                          <span class="tdright">{{reports.generalInfo.vendor_no}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="tdleft col-5">
                          <span class="header-title first_str">Grower/Shipper :</span>
                          <span class="tdleft">{{ reports.generalInfo.grower }}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright col-5">
                          <span class="header-title first_str">Inspection Date :</span>
                          <span class="tdright">{{getDate(reports.generalInfo.inspection_time)}}</span>
                        </td>
                      </tr>

                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">Consignment Number :</span>
                          <span class="tdleft">{{ reports.generalInfo.consignment_num }}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Inspection Time :</span>
                          <span class="tdright">{{getTime(reports.generalInfo.inspection_time)}}</span>
                        </td>
                      </tr>

                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">Purchase Order :</span>
                          <span class="tdleft">{{ reports.generalInfo.purchase_order }}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Inspector Name :</span>
                          <span class="tdright">{{ reports.generalInfo.inspector_name}}</span>
                        </td>
                      </tr>
                       <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">Unit :</span>
                          <span class="tdleft">{{ reports.generalInfo.units }}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Item Description :</span>
                          <span class="tdright">{{ reports.generalInfo.item_description}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">Item Number :</span>
                          <span class="tdleft">{{ reports.generalInfo.item_no }}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Commodity :</span>
                          <span class="tdright">{{ reports.generalInfo.commodity}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">Ordered Quantity :</span>
                          <span class="tdleft">{{ reports.generalInfo.ordered_quantity}}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Variety :</span>
                          <span class="tdright">{{ reports.generalInfo.variety}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">Weight/Quantity Received :</span>
                          <span class="tdleft">{{ reports.generalInfo.recieved_quantity}}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Production Process Code :</span>
                          <span class="tdright">{{ reports.generalInfo.package_type}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">No. of Samples :</span>
                          <span class="tdleft">{{ reports.generalInfo.num_samples}}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Inspection Type :</span>
                          <span class="tdright">{{ reports.generalInfo.inspection_type}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">Trailer Number:</span>
                          <span
                            class="tdleft"
                          >{{ reports.generalInfo.trailer_no?reports.generalInfo.trailer_no:'N/A'}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- GENERAL INFORMATION END -->
              </div>
            </div>
            <br />
            <!-- THIRD CARD DEFECT -->
            <div class="col-12 card pl-0">
              <div class="card-body">
                <div class="row">
                  <div class="col heading_2">Defects</div>
                </div>
                <hr style="border: 1px solid #CACACA;margin-bottom:16px;" />
                <div class="row">
                  <div class="table-responsive" style="padding-left: 15px;padding-right: 15px;">
                    <table class="table table-bordered">
                      <tbody>
                        <tr
                          style="background: #F2F2F2;border: 1px solid #CACACA;box-sizing: border-box;border-radius: 4px;"
                        >
                          <th
                            style="width: 128px;font-weight: 600;border: 1px solid #CACACA;"
                          >Samples</th>
                          <th style="width: 250px;font-weight: 600;border: 1px solid #CACACA;">
                            Weight
                            (lb)/
                            <br />Pulp Temp.(&deg;F)
                            <span v-if="showSpecificGravity">
                              /
                              <br />Specific Gravity
                            </span>
                          </th>
                          <th
                            style="width: 118px; font-weight: 600;border: 1px solid #CACACA;"
                          >Defect</th>
                          <th style="font-weight: 600;border: 1px solid #CACACA;">Type</th>
                          <th style="width: 118px;font-weight: 600;border: 1px solid #CACACA;">
                            Damage
                            <br />(%)
                          </th>
                          <th style="width: 141px;font-weight: 600;border: 1px solid #CACACA;">
                            Serious
                            <br />Damage (%)
                          </th>
                          <th style="width: 88px;font-weight: 600;">
                            Total
                            <br />(%)
                          </th>
                        </tr>
                        <tr v-for="(item, index) in defects" :key="index">
                          <!--#region CheckSum Row -->
                          <td
                            v-if="item.rowType==4"
                            rowspan="1"
                            colspan="4"
                            v-bind:class="['text-center',item.status=='Failed'?'border-new':'border-new']"
                          >
                            {{item.samName}}
                            <span class="bold">Checksum</span>
                          </td>
                          <td
                            v-if="item.rowType==4"
                            v-bind:class="['damage_values',item.status=='Failed'?'border-new':(item.status=='Passed'?'border-new':'border-new')]"
                          >{{item.D==0?'-':Math.round(item.D*100)/100+'%'}}</td>
                          <td
                            v-if="item.rowType==4"
                            v-bind:class="['damage_values',item.status=='Failed'?'border-new':(item.status=='Passed'?'border-new':'border-new')]"
                          >{{item.SD==0?'-':Math.round(item.SD*100)/100+'%'}}</td>
                          <td
                            v-if="item.rowType==4"
                            v-bind:class="[item.status=='Failed'?'border-new text-red':(item.status=='Passed'?'text-green border-new':'text-yellow border-new')]"
                          >{{Math.round(item.Tot*100)/100+'%'}}</td>
                          <!-- CheckSum Row End-->
                          <!-- Blank Row -->
                          <td v-if="item.rowType==0" rowspan="1" colspan="7" class="blank-row"></td>
                          <!-- Blank Row End -->
                          <!-- Row with Result -->
                          <td
                            colspan="3"
                            class="td-defect-items td-background td-result"
                            style="border-right: none;"
                            v-if="item.rowType==3"
                          ></td>
                          <td
                            class="td-defect-items td-background td-result"
                            style="border-left:none"
                            v-if="item.rowType==3"
                          >{{Math.round(item.Tot * 100) / 100}}%</td>
                          <!-- Row with Result End -->

                          <!-- Row With Sample Name -->
                          <td
                            v-if="item.rowType==1"
                            :rowspan="item.samRowSpan"
                            colspan="1"
                          >{{item.samName}}</td>
                          <td v-if="item.rowType==1" :rowspan="item.samRowSpan" colspan="1">
                            {{item.samWT}}/{{item.pulp_temperature}}
                            <span
                              v-if="item.specific_gravity"
                            >/{{item.specific_gravity}}</span>
                          </td>
                          <!-- Row without Sample Name -->
                          <td
                            v-if="item.rowType==1||item.rowType==2"
                            :rowspan="item.rowSpan"
                            colspan="1"
                            class="td-defect-items"
                          >{{item.defname}}</td>

                          <td
                            v-if="item.rowType==1||item.rowType==2||item.rowType==5"
                            :rowspan="item.isLastRow?1:1"
                            colspan="1"
                            class="td-defect-items"
                          >{{item.DefItem}}</td>
                          <td
                            v-if="item.rowType==1||item.rowType==2||item.rowType==5"
                            :rowspan="item.isLastRow?1:1"
                            colspan="1"
                            class="td-defect-items"
                          >{{item.DItem==0?'-':Math.round(item.DItem*100)/100+'%'}}</td>
                          <td
                            v-if="item.rowType==1||item.rowType==2||item.rowType==5"
                            :rowspan="item.isLastRow?1:1"
                            colspan="1"
                            class="td-defect-items"
                          >{{item.SDItem==0?'-':Math.round(item.SDItem*100)/100+'%'}}</td>
                          <td
                            v-if="item.rowType==1||item.rowType==2||item.rowType==5"
                            :rowspan="1"
                            colspan="1"
                            :class="['td-defect-items',(item.status)?'text-green':'text-red']"
                          >{{Math.round(item.TotItem * 100) / 100}}%</td>
                          <!-- Row with Defect head Ends -->
                        </tr>

                        <tr>
                          <td
                            v-bind:class="[(reports.averageCheckSum.status!='Failed')?((reports.averageCheckSum.status!='Border')?'text-green border-green':'text-yellow border-yellow'):'text-red border-red','heading','text-center', 'bold']"
                            colspan="4"
                          >Total Checksum</td>

                          <td
                            v-bind:class="[(reports.averageCheckSum.status!='Failed')?((reports.averageCheckSum.status!='Border')?'text-green border-green':'text-yellow border-yellow'):'text-red border-red']"
                          >{{Math.round(reports.averageCheckSum.damage*100)/100}}%</td>
                          <td
                            v-bind:class="[(reports.averageCheckSum.status!='Failed')?((reports.averageCheckSum.status!='Border')?'text-green border-green':'text-yellow border-yellow'):'text-red border-red']"
                          >{{Math.round(reports.averageCheckSum.seriousDamage*100)/100}}%</td>
                          <td
                            v-bind:class="[(reports.averageCheckSum.status!='Failed')?((reports.averageCheckSum.status!='Border')?'text-green border-green':'text-yellow border-yellow'):'text-red border-red','damage_values']"
                          >{{Math.round(reports.averageCheckSum.total*100)/100}}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- THIRD CARD END -->
            <br />
            <!-- FORTH CARD : BASIC REQUIREMENTS-->
            <div v-if="!hideBasicRequirements" class="col-12 card pl-0">
              <div class="card-body">
                <div class="row">
                  <div class="col heading_2">Basic Requirements</div>
                </div>
                <hr />
                <div class="row">
                  <div class="table-responsive" style="padding-left: 15px;padding-right: 15px;">
                    <table class="table table-bordered">
                      <tbody>
                        <tr class="ro">
                          <th>Samples</th>
                          <th class>Firmness</th>
                          <th class>Cleaness</th>
                          <th class>Shape</th>
                          <th class>Maturity</th>
                          <th class>Skinning</th>
                        </tr>
                        <tr v-for="(item, index) in reports.basicRequirements" :key="index">
                          <td>{{item.name}}</td>
                          <td v-if="item.firmness!==''">{{item.firmness}}</td>
                          <td v-else>N/A</td>
                          <td v-if="item.cleanness!==''">{{item.cleanness}}</td>
                          <td v-else>N/A</td>
                          <td v-if="item.shape!==''">{{item.shape}}</td>
                          <td v-else>N/A</td>
                          <td v-if="item.maturity!==''">{{item.maturity}}</td>
                          <td v-else>N/A</td>
                          <td v-if="item.skinning!==''">{{item.skinning}}</td>
                          <td v-else>N/A</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- FORTH CARD END -->
            <!-- FORTH CARD : BAG COUNT-->
            <div v-if="reports.bagCount.length" class="col-12 card pl-0">
              <div class="card-body">
                <div class="row">
                  <div class="col heading_2">Bag Count</div>
                </div>
                <hr />
                <div class="row">
                  <div class="table-responsive" style="padding-left: 15px;padding-right: 15px;">
                    <table class="table table-bordered">
                      <tbody>
                        <tr class="ro">
                          <th style="width:200px">Samples</th>
                          <th class>Bag Counts</th>
                        </tr>
                        <tr v-for="(item, index) in reports.bagCount" :key="index">
                          <td>{{item.name}}</td>
                          <td class="row p-3 m-0">
                            <div v-for="(val,i) in item.values" class="mr-4" :key="i">
                              <div class="font-weight-bold mb-2">Bag {{i+1}}</div>
                              <div class="text-center">{{val}}</div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- FORTH CARD END -->
            <!-- FIFTH CARD END -->

            <!-- FIFTH CARD: SIZEDESIGNATION -->
            <div class="card col-12 p-0" v-if="reports.type1.length || type2Array.length">
              <div class="card-body">
                <div class="row">
                  <div class="col heading_2">Size Designation</div>
                </div>
                <hr />
                <div class="sub_heading" v-if="reports.type1.length">Type 1</div>
                <div class="row" v-if="reports.type1.length">
                  <div class="col-12">
                    <table class="table table-bordered">
                      <tbody>
                        <tr class="back-color">
                          <th>Sample Number</th>
                          <th>Size Designation</th>
                          <th>
                            Minimum Weight
                            <br />(oz)
                          </th>
                          <th>
                            Maximum Weight
                            <br />(oz)
                          </th>
                          <th>Size(%)</th>
                          <th>Status</th>
                        </tr>

                        <tr v-for="(item, index) in reports.type1" :key="index">
                          <td class="heading">{{ item.name }}</td>
                          <td v-if="item.sizeRange">{{item.sizeRange}}</td>
                          <td v-else>N/A</td>
                          <td v-if="item.minWeight">{{ item.minWeight }} {{ item.unit }}</td>
                          <td v-else>N/A</td>
                          <td v-if="item.maxWeight">{{ item.maxWeight }} {{ item.unit }}</td>
                          <td v-else>N/A</td>
                          <td>
                            <span>
                              <span class="font-weight-bold">UnderSize:&nbsp;</span>
                              {{item.underSize}}%
                            </span>
                            <span>
                              <br />
                              <span class="font-weight-bold">OverSize:&nbsp;</span>
                              {{item.overSize}}%
                            </span>
                          </td>
                          <td
                            v-bind:class="[item.status?'text-green border-new':'border-new text-red']"
                          >{{item.status?"Passed":"Failed"}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="sub_heading" v-if="type2Array.length">Type 2</div>
                <div class="row" v-if="type2Array.length">
                  <div class="col-12">
                    <table class="table table-bordered">
                      <tbody>
                        <tr class="back-color">
                          <th>Sample Number</th>
                          <th>Size Designation</th>
                          <th>
                            Minimum Diameter
                            <br />(in/mm)
                          </th>
                          <th>
                            Maximum Diameter
                            <br />(in/mm)
                          </th>
                          <th>Size(%)</th>
                          <th>Status</th>
                        </tr>

                        <tr v-for="(item, index) in type2Array" :key="index">
                          <td
                            class="heading"
                            v-if="item.rowSpan"
                            :rowspan="item.rowSpan"
                          >{{ item.sample_name }}</td>
                          <td v-if="item.name">{{item.name}}</td>
                          <td v-else>N/A</td>
                          <td v-if="item.minDiameter">{{ item.minDiameter }} {{ item.unit }}</td>
                          <td v-else>N/A</td>
                          <td v-if="item.maxDiameter">{{ item.maxDiameter }} {{ item.unit }}</td>
                          <td v-else>N/A</td>
                          <td>
                            <span v-if="item.hasUnderSize">
                              <span class="font-weight-bold">UnderSize:&nbsp;</span>
                              {{Math.round(item.underSize*100)/100}}%
                            </span>
                            <span v-if="item.hasOverSize">
                              <br />
                              <span class="font-weight-bold">OverSize:&nbsp;</span>
                              {{Math.round(item.overSize*100)/100}}%
                            </span>
                            <span v-if="item.hasWeight">
                              <br />
                              <span class="font-weight-bold">Weight(6Oz / 2-1/2 inch Weight):&nbsp;</span>
                              {{Math.round(item.weight*100)/100}}%
                            </span>
                          </td>
                          <td
                            v-bind:class="[item.status?'text-green border-new':'border-new text-red']"
                          >{{item.status?"Passed":"Failed"}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- FIFTH CARD END -->
            <br />
            <div class="card col-12 pl-0">
              <div class="card-body">
                <div class="form-group">
                  <div class="flex table_heading">
                    <div class="col heading_2 pl-0">Notes</div>
                  </div>
                  <hr />
                  <!-- <textarea
                class="form-control"
                rows="5"
                id="comment"
                style="width : 50%;"
                v-model="reports.basicinfo.comments"
                  ></textarea>-->
                  <!-- Chat-Type Comments -->
                  <table id="count_table">
                    <tr>
                      <td id="count_1" align="left">150 characters</td>
                    </tr>
                  </table>
                  <form
                    v-on:submit="AddComments"
                    autocomplete="off"
                    class="comment-add p-4"
                    style="padding-left:24px !important; padding-top: 0px !important; "
                  >
                    <div class="row">
                      <div
                        class="comment-head text-center"
                      >{{userName.substring(0,2).toUpperCase()}}</div>
                      <textarea
                        class="form-control col-3 comment-input box"
                        type="text"
                        name="comment"
                        id="id_input_comment"
                        v-model="input_comment"
                        placeholder="Add Comment"
                        maxlength="150"
                        style="max-width:17%"
                      />

                      <button class="ml-4 button-submit" style="max-height:40px" type="submit">
                        <span class="sub">Submit</span>
                      </button>
                    </div>
                  </form>
                  <div class="comments-old">
                    <ul>
                      <li v-for="(item, index) in comments.slice(0,3)" class="row" :key="index">
                        <!-- {{item}} -->
                        <div
                          class="comment-head-sm text-center"
                        >{{item.user.substring(0,2).toUpperCase()}}</div>
                        <div>
                          <div class="comment-title">
                            <span class="comment-user">{{item.user}}</span>
                            <span class="comment-date">{{getDate(item.created)}}</span>
                            <span class="comment-date">{{GetTime(item.created)}}</span>
                          </div>
                          <div class="comment-message">{{item.message}}</div>
                        </div>
                      </li>
                    </ul>
                    <ul v-if="showAllComments">
                      <li v-for="(item, index) in comments.slice(3)" class="row" :key="index">
                        <!-- {{item}} -->
                        <div
                          class="comment-head-sm text-center"
                        >{{item.user.substring(0,2).toUpperCase()}}</div>
                        <div>
                          <div class="comment-title">
                            <span class="comment-user">{{item.user}}</span>
                            <span class="comment-date">{{getDate(item.created)}}</span>
                            <span class="comment-date">{{GetTime(item.created)}}</span>
                          </div>
                          <div class="comment-message">{{item.message}}</div>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div v-if="comments.length>3">
                    <span
                      @click="showAllComments=!showAllComments"
                      id="show"
                    >{{showAllComments ? 'Show Less' : 'Show More'}}</span>
                  </div>
                  <span v-if="comments.length>3">
                    <span v-if="showAllComments==false">
                      <hr class="sub-hr" />
                    </span>
                  </span>

                  <!-- Chat-Type Comments End -->
                </div>
              </div>
            </div>
            <br />
            <!-- SIXTH CARD SUMMARY -->

            <div class="col-12 card pl-0">
              <div class="card-body">
                <div class="row">
                  <div class="col heading_2">Summary</div>
                </div>
                <hr />

                <div
                  v-if="reports.averageCheckSum.status=='Passed'"
                  class="status"
                  style="color : #24C656; background: #E0F7EA; border: 1px solid #3CB371 !important; border-radius: 5px; font-weight: bold;"
                >
                  <img class="image_svg" src="@/assets/icons/circle.svg" alt="Tick" />
                  Report Passed
                </div>
                <div
                  v-else-if="reports.averageCheckSum.status=='Failed'"
                  class="status"
                  style="color : #E74C3C;; background:#FCE6E4; border: 1px solid #E74C3C; border-radius: 5px; font-weight: bold;"
                >
                  <img class="image_svg" src="@/assets/icons/Cross.svg" alt="Cross" />
                  Report failed
                </div>
                <div
                  v-else
                  class="status"
                  style="color :#F0A623; background:#FDF2DE; border: 1px solid #F0A623; border-radius: 5px; font-weight: bold;"
                >
                  <img class="image_svg" src="@/assets/icons/warming.svg" alt="Warming" />
                  Report Borderline
                </div>
                <table class="table table-bordered">
                  <tbody>
                    <tr class="back-color">
                      <th></th>
                      <th>External</th>
                      <th>Internal</th>
                      <th>Other</th>
                      <th>Total</th>
                    </tr>
                    <tr v-for="item in reports.defects" :key="item.name">
                      <th class="back-color">{{item.name}}</th>
                      <td
                        v-bind:class="[!item.checkSum.externalStatus && 'text-red ']"
                      >{{item.checkSum.externalTotal?item.checkSum.externalTotal + '%':'-'}}</td>
                      <td
                        v-bind:class="[!item.checkSum.internalStatus && 'text-red ']"
                      >{{item.checkSum.internalTotal?item.checkSum.internalTotal + '%':'-'}}</td>
                      <td
                        v-bind:class="[!item.checkSum.otherStatus && 'text-red ']"
                      >{{item.checkSum.otherTotal?item.checkSum.otherTotal + '%':'-'}}</td>
                      <td
                        v-bind:class="[item.checkSum.status=='Passed'?'text-green ':(item.checkSum.status=='Failed'?'text-red ':'text-yellow')]"
                      >{{item.checkSum.total?item.checkSum.total + '%':'-'}}</td>
                    </tr>
                    <tr style="border:none">
                      <td colspan="5" class="blank-row"></td>
                    </tr>
                    <tr>
                      <th class="back-color">Total CheckSum</th>
                      <td
                        v-bind:class="[!reports.averageCheckSum.externalStatus && 'text-red ']"
                      >{{reports.averageCheckSum.externalTotal?reports.averageCheckSum.externalTotal + '%':'-'}}</td>
                      <td
                        v-bind:class="[!reports.averageCheckSum.internalStatus && 'text-red ']"
                      >{{reports.averageCheckSum.internalTotal?reports.averageCheckSum.internalTotal + '%':'-'}}</td>
                      <td
                        v-bind:class="[!reports.averageCheckSum.otherStatus && 'text-red ']"
                      >{{reports.averageCheckSum.otherTotal?reports.averageCheckSum.otherTotal + '%':'-'}}</td>
                      <td
                        v-bind:class="[reports.averageCheckSum.status=='Passed'?'text-green ':(reports.averageCheckSum.status=='Failed'?'text-red ':'text-yellow')]"
                      >{{reports.averageCheckSum.total?reports.averageCheckSum.total + '%':'-'}}</td>
                    </tr>
                  </tbody>
                </table>

                <ol>
                  <li
                    v-for="(item,index) in reports.failed_sizes"
                    class="heading_2"
                    :key="index"
                  >{{item.sample}} failed to make size classification "{{item.name}}".</li>
                </ol>
              </div>
            </div>

            <!-- <div
                v-if="reports.averageCheckSum.status=='Passed'"
                class="status"
                style="color : #24C656; background: #E0F7EA; border: 1px solid #3CB371 !important; border-radius: 5px; font-weight: bold;"
              >
                <img class="image_svg" src="@/assets/icons/circle.svg" alt="Tick" />
                Report Passed, Weighted Avg total
                <span
                  style="font-weight:bolder"
                >{{reports.averageCheckSum.total}}%</span>
                is below Threshold tolerance of {{Math.round(reports.averageCheckSum.total *100)/100 }}%
              </div>
              <div
                v-else-if="reports.averageCheckSum.status=='Failed'"
                class="status"
                style="color : #E74C3C;; background:#FCE6E4; border: 1px solid #E74C3C; border-radius: 5px; font-weight: bold;"
              >
                <img class="image_svg" src="@/assets/icons/Cross.svg" alt="Cross" />
                Report failed, Weighted Avg total
                <span
                  style="font-weight:bolder"
                >{{reports.averageCheckSum.total}}%</span>
                is above Threshold tolerance of {{Math.round(reports.averageCheckSum.total *100)/100 }}%
              </div>
              <div
                v-else
                class="status"
                style="color :#F0A623; background:#FDF2DE; border: 1px solid #F0A623; border-radius: 5px; font-weight: bold;"
              >
                <img class="image_svg" src="@/assets/icons/warming.svg" alt="Warming" />
                Report Borderline, Weighted Avg total
                <span
                  style="font-weight:bolder"
                >{{reports.averageCheckSum.total}}%</span>
                is close to Threshold tolerance of {{Math.round(reports.averageCheckSum.total *100)/100 }}%
              </div>
              <div class="row top_up" v-for="(item,index) in reports.defects" :key="index">
                <div v-if="item.checkSum.status=='Passed'" class="status" style="color : #24C656; ">
                  <span class="side_text">{{item.name}}</span> Passed, Total defects
                  <span style="font-weight:bolder">{{item.checkSum.total}}%</span>
                  is below threshold {{reports.averageCheckSum.threshold}}%
                </div>
                <div
                  v-else-if="item.checkSum.status=='Failed'"
                  class="status"
                  style="color : #E74C3C;"
                >
                  <span class="side_text">{{item.name}}</span> Failed, Total defects
                  <span style="font-weight:bolder">{{item.checkSum.total}}%</span>
                  is above threshold {{reports.averageCheckSum.threshold}}%
                </div>
                <div v-else class="status" style="color :#F0A623;">
                  <span class="side_text">{{item.name}}</span> Border, Total defects
                  <span style="font-weight:bolder">{{item.checkSum.total}}%</span>
                  is close to threshold {{reports.averageCheckSum.threshold}}%
                </div>
            </div>-->

            <!-- SIXTH CARD END -->
            <br />
            <!-- SEVENTH CARD IMAGES -->
            <div class="col-12 card pl-0" v-if="showImages">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <div class="flex table_heading">
                      <div class="col heading_2 pl-0">Sample Images</div>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-12">
                    <table class="table table-bordered">
                      <thead class="back-color">
                        <th style="width:108px">Sample</th>
                        <th>Images</th>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in imageUrls" v-bind:key="index">
                          <td v-if="item.length">sample_{{index}}</td>
                          <td v-if="item.length">
                            <div class="row" ref="imagerow">
                              <div class="m-2" v-for="(url, index) in item " :key="index">
                                <img
                                  class="sample-images"
                                  :key="index"
                                  :src="url.url"
                                  style=" border-radius:4px;margin:10px;  "
                                />
                                <ol type="1" class="new_ol">
                                  <li
                                    class="list_style"
                                    v-for="(tag,index) in url.tags"
                                    :key="index"
                                  >{{tag}}</li>
                                </ol>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- SEVENTH CARD END -->
          </div>
        </div>
        <br />
        <br />
        <div>
          <!-- <button @click="ConfirmReport" class="print_button col-2">Confirm</button>
          <button @click="ReturnToSample" class="download_button col-2">Edit</button>-->
          <div class="text-right">
            <b-dropdown split text="Download" @click="download()" class="m-2 download_button">
              <b-dropdown-item href="#" @click="print()">Download Condensed Report</b-dropdown-item>
            </b-dropdown>
            <!-- <div class="col-2"></div> -->
            <!-- <button @click="download()" class="download_button col-2">Download</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
var docId;
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState, mapActions } from "vuex";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import baseUrl from "@/baseurl";

import VLazyImage from "v-lazy-image";
export default {
  name: "PotatoReport",
  data() {
    return {
      showAllImages: false,
      showAllComments: false,
      maxCount: 150,
      remainingCount: 150,
      message: "",
      hasError: false,
      len: false,
      isMounted: false,
      image_row_width: 0,
      input_comment: "",
      //  imageKeys : this.getImageKeys()
    };
  },
  props: ["maximized"],
  computed: {
    noEditFlag() {
      return this.$store.state.nonEditFlag;
    },
    sample_num() {
      this.$store.state.reports.generalInfo.num_samples;
    },

    showImages() {
      console.log(this.imageUrls);
      for (let i in this.imageUrls) {
        let sample = this.imageUrls[i];
        if (sample.length > 0) return true;
      }
      return false;
    },
    showSpecificGravity() {
      let out = false;
      for (let i in this.reports.defects) {
        let sample = this.reports.defects[i];
        out = out || sample.specific_gravity;
      }
      return out;
    },
    hideBasicRequirements() {
      var i = 0;
      this.reports.basicRequirements.forEach((item) => {
        if (
          item.firmness !== "" ||
          item.cleanness !== "" ||
          item.shape !== "" ||
          item.maturity !== "" ||
          item.skinning !== ""
        ) {
          // console.log(" in hideBasicRequirements");
          i += 1;
        }
      });
      return i == 0;
    },
    docId() {
      return this.$route.params.docId;
    },
    userName() {
      return this.$store.state.username;
    },
    user() {
      return this.$store.state.user;
    },

    comments() {
      return this.$store.state.reportComments;
    },
    defects() {
      return this.getDefects();
      return [];
    },
    reports() {
      return this.$store.state.reports;
    },
    type2Array() {
      return this.getType2Arr(this.reports.type2s);
    },
    imageUrls() {
      return this.$store.state.reportUrl;
    },
    prevRoute() {
      // if (
      //   !this.$store.state.prevRoute.includes(`/sample`) &&
      //   !this.$store.state.prevRoute.includes("/summary/")
      // ) {
      //   if (this.noEditFlag)
      //     this.$router.push(`/app/secure/inspectionSummary/summary`);
      //   else
      //     this.$router.push(`/app/secure/inspectionTemplate/generalInfo/potato`);
      // }
      // return this.$store.state.prevRoute;
    },
  },
  watch: {
    //setTimeout(myFunction, 3000)
    maximized: function () {
      if (this.maximized) {
        // console.log("i am", this.maximized);
        setTimeout(() => {
          this.setImageNum(320);
        }, 500);
      } else {
        this.setImageNum(448);
      }
    },
    prevRoute(newVal, oldVal) {
      // if (!newVal.includes(`/sample`)) {
      //   if (this.noEditFlag)
      //     this.$router.push(`/app/secure/inspectionSummary/summary`);
      //   else
      //     this.$router.push(`/app/secure/inspectionTemplate/generalInfo/potato`);
      // }
    },
  },
  methods: {
    getDate(date) {
      var dt = new Date(date);
      var month = dt.getMonth();
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      var day = dt.getDate();

      var year = dt.getFullYear();

      return months[month] + "-" + day + "-" + year;
    },
    getTime(time) {
      var dt = new Date(time);
      return `${dt.getHours()}:${dt.getMinutes()}`;
    },

    GetTime(dt) {
      dt = new Date(dt);
      var hr = dt.getHours();
      hr = hr > 9 ? "" + hr : "0" + hr;
      var min = dt.getMinutes();
      min = min > 9 ? "" + min : "0" + min;
      return hr + ":" + min;
    },
    setImageNum(num) {
      this.image_row_width = ~~((window.innerWidth - num) / 188);
    },
    getType2Arr(type2 = []) {
      var type2arr = [];

      for (var index in type2) {
        var object = type2[index];
        // ROWTYPE:
        // 1= With SampleName
        // 2= without SampleName with defect title
        var sample_name = object.name;
        var rowSpan = object.values.length;
        for (var i in object.values) {
          let data = { rowType: 2, ...object.values[i] };
          if (i == 0)
            data = { sample_name, rowSpan, rowType: 1, ...object.values[i] };
          type2arr.push(data);
        }
      }
      return type2arr;
    },
    getDefects() {
      let defects = [];
      for (let index in this.reports.defects) {
        let sample = this.reports.defects[index];
        // ROWTYPE:
        // 0= BlankROw
        // 1= With SampleName
        // 2= without SampleName with defect title
        // 3= with defect Total
        // 4= with Check Sum
        // 5= without defect title
        let samRowSpan = 3;
        samRowSpan += sample.externals.length ? sample.externals.length : 1;
        samRowSpan += sample.internals.length ? sample.internals.length : 1;
        samRowSpan += sample.others.length ? sample.others.length : 1;
        if (sample.externals.length == 0)
          defects.push({
            rowType: 1,
            rowSpan: 2,
            samName: sample.name,
            samRowSpan,
            defname: "External",
            samWT: sample.sample_weight,
            pulp_temperature: sample.pulp_temperature,
            specific_gravity: sample.specific_gravity,
            defRowSpan: 1,
            DefItem: "No defect found",
            DItem: 0,
            SDItem: 0,
            TotItem: 0,
            status: true,
          });
        for (let j in sample.externals) {
          let item = sample.externals[j];
          if (j == 0) {
            defects.push({
              rowType: 1,
              defname: "External",
              samRowSpan,
              rowSpan: sample.externals.length + 1,
              samName: sample.name,
              samWT: sample.sample_weight,
              pulp_temperature: sample.pulp_temperature,
              specific_gravity: sample.specific_gravity,
              defRowSpan: sample.externals.length,
              DefItem: item.name,
              DItem: item.damage,
              SDItem: item.seriousDamage,
              TotItem: item.total,
              status: item.status,
            });
          } else {
            defects.push({
              rowType: 5,
              DefItem: item.name,
              DItem: item.damage,
              SDItem: item.seriousDamage,
              TotItem: item.total,
              status: item.status,
            });
          }
        }
        defects.push({
          rowType: 3,

          Tot: sample.checkSum.externalTotal,
        });

        if (sample.internals.length == 0)
          defects.push({
            rowType: 2,
            rowSpan: 2,
            defname: "Internal",
            samName: sample.name,
            samWT: sample.sample_weight,
            pulp_temperature: sample.pulp_temperature,
            specific_gravity: sample.specific_gravity,
            defRowSpan: 1,
            DefItem: "No defect found",
            DItem: 0,
            SDItem: 0,
            TotItem: 0,
            status: true,
          });
        for (let j in sample.internals) {
          let item = sample.internals[j];
          if (j == 0) {
            defects.push({
              rowType: 2,
              rowSpan: sample.internals.length + 1,
              samName: sample.name,
              defname: "Internal",
              samWT: sample.sample_weight,
              pulp_temperature: sample.pulp_temperature,
              specific_gravity: sample.specific_gravity,
              defRowSpan: sample.internals.length,
              DefItem: item.name,
              DItem: item.damage,
              SDItem: item.seriousDamage,
              TotItem: item.total,
              status: item.status,
            });
          } else {
            defects.push({
              rowType: 5,
              DefItem: item.name,
              DItem: item.damage,
              SDItem: item.seriousDamage,
              TotItem: item.total,
              status: item.status,
            });
          }
        }
        defects.push({
          rowType: 3,
          Tot: sample.checkSum.internalTotal,
        });

        if (sample.others.length == 0)
          defects.push({
            rowType: 2,
            rowSpan: 2,
            samName: sample.name,
            samWT: sample.sample_weight,
            defname: "Other",
            pulp_temperature: sample.pulp_temperature,
            specific_gravity: sample.specific_gravity,
            defRowSpan: 1,
            DefItem: "No defect found",
            DItem: 0,
            SDItem: 0,
            TotItem: 0,
            status: true,
          });
        for (let j in sample.others) {
          let item = sample.others[j];
          if (j == 0) {
            defects.push({
              rowType: 2,
              defname: "Other",
              rowSpan: sample.others.length + 1,
              samName: sample.name,
              samWT: sample.sample_weight,
              pulp_temperature: sample.pulp_temperature,
              specific_gravity: sample.specific_gravity,
              defRowSpan: sample.others.length,
              DefItem: item.name,
              DItem: item.damage,
              SDItem: item.seriousDamage,
              TotItem: item.total,
              status: item.status,
            });
          } else {
            defects.push({
              rowType: 5,
              DefItem: item.name,
              DItem: item.damage,
              SDItem: item.seriousDamage,
              TotItem: item.total,
              status: item.status,
            });
          }
        }
        defects.push({
          rowType: 3,
          Tot: sample.checkSum.otherTotal,
        });

        defects.push({
          rowType: 0,
        });
        defects.push({
          rowType: 4,
          samName: sample.name,
          D: sample.checkSum.damage,
          SD: sample.checkSum.seriousDamage,
          Tot: sample.checkSum.total,
          status: sample.checkSum.status,
        });
        defects.push({
          rowType: 0,
        });
      }
      return defects;
    },
    async AddComments(e) {
      e.preventDefault();
      this.$store.dispatch("showLoader", true);
      var comment = {
        message: this.input_comment,
      };
      if (comment.message.trim().length > 0) {
        await this.$store.dispatch("postPotatoComment", {
          docId: this.docId,
          data: comment,
        });
        this.input_comment = "";
      }
      this.$store.dispatch("showLoader", false);
      // document.getElementById('id_input_comment').val=""
    },

    download() {
      // DOWNLOAD USING PRINT FUNCTION
      window.open(baseUrl + "/api/potato/pdf/" + this.docId);
    },

    print() {
      // DOWNLOAD USING PRINT FUNCTION
      window.open(baseUrl + "/api/potato/pdfcondensed/" + this.docId);
    },

    synchronizeCssStyles(src, destination, recursively) {
      // if recursively = true, then we assume the src dom structure and destination dom structure are identical (ie: cloneNode was used)

      // window.getComputedStyle vs document.defaultView.getComputedStyle
      // @TBD: also check for compatibility on IE/Edge
      destination.style.cssText = document.defaultView.getComputedStyle(
        src,
        ""
      ).cssText;

      if (recursively) {
        var vSrcElements = src.getElementsByTagName("*");
        var vDstElements = destination.getElementsByTagName("*");

        for (var i = vSrcElements.length; i--; ) {
          var vSrcElement = vSrcElements[i];
          var vDstElement = vDstElements[i];
          //          console.log(i + " >> " + vSrcElement + " :: " + vDstElement);
          vDstElement.style.cssText = document.defaultView.getComputedStyle(
            vSrcElement,
            ""
          ).cssText;
        }
      }
    },
  },
  mounted: async function () {
    this.$store.dispatch("showLoader", true);
    await this.$store.dispatch("getPotatoReport", this.docId);
    await this.$store.dispatch("getPotatoComment", this.docId);

    await this.$store.dispatch("getImages", {
      docId: this.docId,
      commodity: "potato",
    });
    this.reports;
    this.setImageNum(this.maximized ? 320 : 448);
    this.isMounted = true;

    this.$store.commit("showLoader", false);
    document.getElementsByClassName("midSection")[0].scrollTo(0, 0);
  },
  created: function () {
    if (!this.$route.path.includes("inspectionSummary")) {
      this.$store.commit("changePathLabel", {
        view: "Create Inspection",
        categories: [
          { name: "General Inspection", focus: false },
          { name: "Sample Inspection", focus: false },
          { name: "Preview", focus: false },
          { name: "Report", focus: true },
        ],
      });
    } else {
      this.$store.commit("changePathLabel", {
        view: "Inspection Report",
        categories: [
          { name: "Summary", focus: true },
          { name: "Report", focus: true },
        ],
      });
    }
  },
};
</script>

<style >

.download_button {
  border-radius: 5px;
  height: 35px;
}
.download_button .btn-secondary {
  background: #24c656;
  color: #fff;
  border: none;
}
.download_button .btn-secondary:hover {
  background: #1da749;
  color: #fff;
}
.dropdown-menu.show{
  top:10px!important;
  left: -155px!important;
}
</style>

<style scoped>
/* STYLING FOR BASIC INFO */
.card-body {
  padding: 8px 14px;
}
.table-Logo td {
  border: 0px;
}

.card hr {
  margin: 8px 0;
}
td.tdleft {
  text-align: left;
  width: max-content;
  white-space: nowrap;
  padding: 2px;
  border: 0px;
}

.Agsift-logo {
  height: 40px;
}
.report-logo {
  height: 40px;
  text-align: center;
}
td.tdright {
  text-align: left;
  white-space: nowrap;
  width: max-content;
  padding: 2px;
  border: 0px;
}
.header-title {
  font-weight: 600;
}
.image_svg {
  width: 30px;
  height: 30px;
  color: #24c656;
  margin-right: 12px;
}
.table_heading {
  position: relative;
  display: flex;
  width: 100%;
  margin-bottom: 10px;
}
.table_heading .text {
  width: 200px;
  text-align: center;
  background: #ffa245;
  padding: 9px;
  color: #ffffff;
  border-radius: 30px;
}
.table_heading hr {
  width: 100%;
  color: #ffa245;
  border-color: #ffa245;
  margin-left: 4px;
  margin-top: 8px;
}

.button-submit {
  background: #ffffff;
  border: 1px solid #24c656;
  box-sizing: border-box;
  border-radius: 4px;
}
.nav-pills .nav-link.active.singleLink {
  background: transparent !important;
  font-size: 32px;
  color: #000000;
  text-align: left;
  width: 100%;
  padding: 0px;
}
.border-red {
  border: 1px solid #da0404 !important;
}
.border-green {
  border: 1px solid #3ac47b !important;
}
.border-yellow {
  border: 1px solid rgb(189, 183, 0) !important;
}
.width200 {
  width: 200px;
}
.sub {
  padding: 10px 16px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;

  /* identical to box height */

  color: #24c656;
}
.failed {
  color: #e74c3c;
}
.passed {
  color: #24c656;
}
.borderline {
  color: #f0a623;
}
#count_1 {
  padding-left: 0px;
}
.sub-hr {
  border: 1px solid #d7d9e0;
  width: 30%;
}
.back-color {
  background: #fafafa;
}
.sub_heading {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;

  /* identical to box height */

  color: #29342e;
  padding-bottom: 16px;
}
table {
  border-radius: 4px;
}
.Approve_Message {
  color: #ffa245;
  /* color: #fff; */
  border-radius: 5px;
  /* bottom: 4%;
  left: 80%; */
  width: 9%;
  height: 35px;
}
.Approve_button {
  background: #24c656;
  position: relative;
  color: #fff;
  border-radius: 5px;
  bottom: 4%;
  left: 90%;
  width: 9%;
  height: 35px;
}

.print_button {
  background: #24c656;
  /* position: relative; */
  color: #fff;
  border-radius: 5px;
  bottom: 4%;
  width: 9%;
  height: 35px;
  margin-right: 40px;
}
.bold {
  font-weight: 600;
}
.purpleColor {
  color: #6037c0;
}
.side_text {
  font-weight: 600;
  margin-right: 24px;
  margin-left: 9px;
}
th {
  color: #29342e;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #aeb6bf;
  border-radius: 4px;
}
.table-bordered th {
  border: 1px solid rgb(202, 202, 202);
  white-space: normal; /*change-here*/
  font-size: 1.1rem;
}
.blank-row {
  border: 0px !important;
}
.td-defect {
  background-color: #ffa24520;
}
.td-defect-items {
  vertical-align: text-top;
  padding: 5px 0 5px 0;
}
.table-bordered td.damage_values {
  white-space: nowrap;
}
.status {
  color: #fff;
  padding: 7px;
  font-size: 16px;
  margin: 15px 0;
  opacity: 0.8;
  width: max-content;
}
.table-bordered td,
.table-bordered th {
  padding-left: 20px;
}
td,
th {
  text-align: left;
  vertical-align: middle;
}
.new_ol {
  padding-left: 37px;
}
.td-background {
  background-color: #f9f9f9;
}
.td-result {
  padding: 0px;
}
.check-sum {
  border: 1px solid #ffa245 !important;
}
.heading {
  font-weight: bold;
}
.margin {
  margin-right: 10px;
  margin-left: 10px;
}
.textdirection {
  transform: rotate(270deg);
}

.textdirection1 {
  transform: rotate(315deg);
}
.text-red {
  background-color: #ffeaea;
}
.text-green {
  background-color: #e3fff0;
}
.text-yellow {
  background-color: #ffffe0;
}
.report_table {
  /* changed here for styles*/
  height: 80vh;
  overflow: auto;
}
#show_2 {
  cursor: pointer;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  padding-left: 90%;
  color: #24c656;
  text-align: right;
  margin-right: 16px;
}
#show {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  padding-left: 13%;
  color: #24c656;
  cursor: pointer;
}

.list_style {
  font-size: 14px;
  line-height: 18px;

  /* identical to box height */

  color: #29342e;
}
hr {
  border: 1px solid #cacaca;
  margin-bottom: 16px;
}
.sample-images {
  height: 140px;
  width: 140px;
}

/* Comment Section  */

.comment-head {
  background-color: #3cb371 !important;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
  font-size: 17px;
  padding: 7px;
}

.comment-submit {
  height: 40px;
  width: 40px;
  margin: 0;
  border: 0;
  padding: 0;
}
.comment-head-sm {
  background-color: #6037c0 !important;
  border: none;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: white;
  font-size: 14px;
  padding: 7px;
  margin-top: 8px;
  text-align: center;
}
.comment-input {
  margin-left: 10px;
  height: 40px;
}
.comment-user {
  padding-left: 10px;
  font-weight: 600;
}
.comment-date {
  padding-left: 10px;
  font-weight: normal;
  font-size: 10px;

  color: #b4b4b4;
}
.comment-message {
  padding: 0px 10px 10px 10px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  max-width: 50vw;

  color: #29342e;
}
.sample-images {
  height: 140px;
  width: 140px;
}
#mid_table {
  margin-right: 2%;
}
#report {
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  color: #29342e;
}
.ro {
  background-color: #f2f2f2;
}
#count_table {
  margin-left: 18%;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 13px;
  color: #b4b4b4;
}
.first_hr {
  border: 1px solid #cacaca;
}
.first_str {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #29342e;
}
#inspection_role {
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 30px;
  text-decoration-line: underline;
  margin-bottom: 24px;
  color: #29342e;
}
#approved_button {
  background: #effaff;
  border: 1px solid #11abeb;
  box-sizing: border-box;
  border-radius: 4px;
  width: 85px;
  height: 30px;
  margin-left: 12px;
  color: #11abeb;
  cursor: default;
}
#status_btn {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;

  color: #11abeb;
}
.table_top {
  margin-top: -26px;
}
#status_btn_pen {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;

  color: #b4b4b4;
}
.box {
  border: 1px solid #b4b4b4;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 16px;
}
#mid_td {
  padding-left: 49%;
}
#powerd_by {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  color: #24c656;
}
#pen_button {
  width: 77px;
  height: 30px;
  margin-left: 12px;
  background: #f9f9f9;
  border: 1px solid #b4b4b4;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: default;
}
.heading_2 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #29342e;
}
.count {
  padding-left: 17%;
}
.maxi {
  height: 240px;
  overflow: hidden;
}
.card {
  background: #ffffff;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  width: 100%;
  padding-bottom: 16px;
  margin-top: 16px;
}
.border-new {
  border: 1px solid #cacaca;
}
.top_up {
  margin-top: -15px;
}
</style>